"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxOption = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = require("react");
var _spacing = require("../../../constants/spacing");
var _checkbox = require("../../checkbox");
var _StyledOption = require("./StyledOption");
/** @jsxRuntime classic */
/** @jsx jsx */

const StyledMultiSelectCheckbox = /*#__PURE__*/(0, _react.memo)((0, _styled.default)(_checkbox.Checkbox)`
    margin-right: ${_spacing.sizes.xSmall}px;
    vertical-align: middle;
`);
const noopClickHandler = () => {
  // Nothing here intentionally - the Checkbox is purely presentational.
  // Its state is controlled by its parents.
};
const CheckboxOption = props => {
  const {
    checkedState,
    children,
    isDisabled,
    isFocused,
    isSelected
  } = props;
  return (0, _core.jsx)(_StyledOption.StyledOption, (0, _extends2.default)({
    className: props.className,
    ref: props.innerRef
    // TODO optionHeight should be moved to the LayoutContext.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    ,
    height: props.selectProps.optionHeight,
    isDisabled: isDisabled,
    isFocused: isFocused,
    isSelected: isSelected
  }, props.innerProps), (0, _core.jsx)(_react.Fragment, null, (0, _core.jsx)(StyledMultiSelectCheckbox, {
    "aria-hidden": true,
    tabIndex: -1,
    checkedState: checkedState,
    isDisabled: isDisabled,
    onClick: noopClickHandler
  }), children));
};
exports.CheckboxOption = CheckboxOption;
//# sourceMappingURL=CheckboxOption.js.map